import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuItem, Select, Stack, TextField, } from "@mui/material";
import { useCallback } from "react";
import { timePeriods } from "./core/index.js";
const FlowRateInput = ({ value, onChange, onBlur }) => {
    const { amountEther, period = "month" } = value ?? {};
    const onAmountEtherChange = useCallback((e) => {
        onChange({ amountEther: e.target.value, period });
    }, [period]);
    const onPeriodChange = useCallback((e) => {
        onChange({
            amountEther: (amountEther ?? ""),
            period: e.target.value,
        });
    }, [amountEther]);
    return (_jsxs(Stack, { gap: "-1px", sx: { display: "grid", gridTemplateColumns: "2fr 1fr" }, children: [_jsx(TextField, { "data-testid": "custom-flow-rate-input-field", fullWidth: true, value: amountEther, onChange: onAmountEtherChange, onBlur: onBlur, InputProps: {
                    sx: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0,
                    },
                } }), _jsx(Select, { "data-testid": "custom-time-unit-dropdown", value: period, onChange: onPeriodChange, onBlur: onBlur, sx: {
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    marginLeft: "-1px",
                }, children: timePeriods.map((interval) => (_jsxs(MenuItem, { value: interval, children: ["/", interval] }, interval))) })] }));
};
export default FlowRateInput;
